module.exports = __webpack_public_path__ + "static/media/opoyi-logo.671c5f46.svg";